export default __webpack_public_path__ + "static/media/Amtrak_Routes.392e0d72.geojson";